import { Checkbox, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { grey } from "@mui/material/colors"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"

export function GroupSelectorSearchItem({ item }) {
    const { selected, onToggle } = useBoundContext()
    const isSelected = (selected ?? []).includes(item?.id)

    return (
        <ListItemButton
            onClick={handleToggle}
            sx={{ borderBottom: `1px solid ${grey[200]}`, minHeight: "50px" }}
            data-cy="group-selector-search-item"
        >
            <Checkbox
                checked={isSelected}
                size="small"
                sx={{ mr: 0.5 }}
                onClick={stopPropagation}
                onChange={handleToggle}
            />
            <ListItemIcon sx={{ minWidth: 32 }}>
                <Iconify icon="ic:twotone-folder" sx={{ color: "primary.main", width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary={item?.name} secondary={item?.path} />
        </ListItemButton>
    )

    function stopPropagation(e) {
        e.stopPropagation()
    }

    function handleToggle() {
        onToggle(item?.id)
    }
}
